import {RemoteGetProvidersList} from 'data/usecases/private/authorizations/remote-get-providers-list';
import {GetProvidersList} from 'domain/usecases/private/authorizations/get-providers-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetProvidersList = (): GetProvidersList =>
	new RemoteGetProvidersList(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.providers),
		makeAuthorizeHttpClientDecorator(),
	);
